module.exports = __webpack_public_path__ + "img/logoazul.774a9899.svg";